import { Eye } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const ViewCounter = () => {
  const { data } = useQuery({ queryKey: ["views"], queryFn: api.views, refetchInterval: 60000 });
  if (!data) return null;
  return (
    <span title="People who viewed your page · only you can see this" data-testid="view-counter"
      className="flex items-center gap-1.5 px-2.5 py-1 rounded-full border border-white/10 text-xs text-slate-300 whitespace-nowrap">
      <Eye size={13} className="text-sky-300" />
      <span data-testid="view-counter-total">{data.total}</span>
      <span className="hidden sm:inline text-slate-500">views</span>
      <span className="text-emerald-300/90 text-[11px] max-[380px]:hidden" data-testid="view-counter-week">+{data.week}<span className="hidden sm:inline"> this week</span></span>
    </span>
  );
};
